export function formatCurrency(value: number) {
  const dollarUSLocale = Intl.NumberFormat("en-US");
  return dollarUSLocale.format(value);
}
